var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _path16, _rect, _rect2, _path17, _path18, _path19, _path20, _rect3, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 708 555.87",
    width: 708,
    height: 555.86743,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m890.47 679.51a211.72 211.72 0 0 1-46.196 37.27c-0.39154 0.24069-0.7897 0.4667-1.1892 0.70031l-27.639-24.463c0.29035-0.26957 0.61188-0.57235 0.95806-0.90494 20.594-19.555 122.83-156.28 129.64-189.57-0.47014 2.7738 6.1472 111.55-55.577 176.97z",
    fill: "#f0f0f0",
    "data-name": "Path 133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m849.6 721.51c-0.52265 0.12466-1.0544 0.24137-1.5876 0.34772l-20.736-18.353c0.40524-0.14119 0.87883-0.30927 1.4205-0.49568 8.8966-3.1503 35.394-12.66 61.764-23.492 28.334-11.644 56.533-24.8 62.598-33.227-1.3009 1.9581-41.374 61.336-103.46 75.219z",
    fill: "#f0f0f0",
    "data-name": "Path 134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m890.08 317.65h-2.9529v-80.894a46.819 46.819 0 0 0-46.819-46.819h-171.38a46.819 46.819 0 0 0-46.819 46.819v443.79a46.819 46.819 0 0 0 46.819 46.819h171.38a46.819 46.819 0 0 0 46.819-46.819v-305.31h2.9529z",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m877.16 237.07v443.14a34.957 34.957 0 0 1-34.969 34.957h-172.21a34.954 34.954 0 0 1-34.957-34.957v-443.14a34.954 34.954 0 0 1 34.957-34.957h20.898a16.619 16.619 0 0 0 15.383 22.88h98.181a16.601 16.601 0 0 0 15.384-22.88h22.362a34.957 34.957 0 0 1 34.969 34.957z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m823.59 467.36h-151.37a10.011 10.011 0 0 1-10-10v-4.9775a10.011 10.011 0 0 1 10-10h151.37a10.011 10.011 0 0 1 10 10v4.9775a10.011 10.011 0 0 1-10 10z",
    fill: "#f0f0f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m823.59 510.26h-151.37a10.011 10.011 0 0 1-10-10v-4.9775a10.011 10.011 0 0 1 10-10h151.37a10.011 10.011 0 0 1 10 10v4.9775a10.011 10.011 0 0 1-10 10z",
    fill: "#f0f0f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m831.17 457.76h-151.37a10.512 10.512 0 0 1-10.5-10.5v-4.9775a10.512 10.512 0 0 1 10.5-10.5h151.37a10.512 10.512 0 0 1 10.5 10.5v4.9775a10.512 10.512 0 0 1-10.5 10.5zm-151.37-23.978a8.5095 8.5095 0 0 0-8.5 8.5v4.9775a8.5095 8.5095 0 0 0 8.5 8.5h151.37a8.5095 8.5095 0 0 0 8.5-8.5v-4.9775a8.5095 8.5095 0 0 0-8.5-8.5z",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m831.17 500.67h-151.37a10.512 10.512 0 0 1-10.5-10.5v-4.9775a10.512 10.512 0 0 1 10.5-10.5h151.37a10.512 10.512 0 0 1 10.5 10.5v4.9775a10.512 10.512 0 0 1-10.5 10.5zm-151.37-23.978a8.5095 8.5095 0 0 0-8.5 8.5v4.9775a8.5095 8.5095 0 0 0 8.5 8.5h151.37a8.5095 8.5095 0 0 0 8.5-8.5v-4.9775a8.5095 8.5095 0 0 0-8.5-8.5z",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m877.16 237.07v96.39a103.54 103.54 0 0 1-129.88-100.07q0-4.2402 0.34076-8.3922h56.826a16.601 16.601 0 0 0 15.384-22.88h22.362a34.957 34.957 0 0 1 34.969 34.957z",
    fill: "#f0f0f0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m722.04 709.15c0 2.0318-0.0758 4.0383-0.23971 6.0196h-51.817a34.954 34.954 0 0 1-34.957-34.957v-47.4a77.073 77.073 0 0 1 87.013 76.337z",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m304.12 625.98a6.0068 6.0068 0 0 0 7.911-3.0669l46.679-105.79a13.379 13.379 0 0 0-17.077-17.876h-1.2e-4a13.199 13.199 0 0 0-6.7501 5.7803 13.649 13.649 0 0 0-0.65442 1.293l-46.679 105.79a5.9996 5.9996 0 0 0 3.0674 7.9116z",
    fill: "#6c63ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m356.8 560.56-46.172-10.261 11.428-30.232a31.95 31.95 0 0 1 34.299-23.628l0.44483 0.04931z",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m450.06 627.5a7.0281 7.0281 0 0 1-6.4119-4.1768l-46.679-105.79a14.381 14.381 0 0 1 25.609-12.997v-4.9e-4a14.618 14.618 0 0 1 0.70264 1.3882l46.679 105.79a7.0001 7.0001 0 0 1-3.5786 9.23l-13.961 6.1597-0.00708-0.01562a6.9441 6.9441 0 0 1-2.3531 0.41204z",
    fill: "#6c63ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m385.49 591.17a6.0067 6.0067 0 0 0-6 6v123.01a6.0067 6.0067 0 0 0 6 6h14.76a6.0067 6.0067 0 0 0 6-6v-123.01a6.0067 6.0067 0 0 0-6-6z",
    fill: "#6c63ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m356.29 591.17a6.0067 6.0067 0 0 0-6 6v123.01a6.0067 6.0067 0 0 0 6 6h14.76a6.0067 6.0067 0 0 0 6-6v-123.01a6.0067 6.0067 0 0 0-6-6z",
    fill: "#6c63ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 131.83,
    cy: 239.22,
    r: 51,
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m394.8 432.7c3.3059-0.09179 7.4203-0.20654 10.59-2.522a8.1327 8.1327 0 0 0 3.2001-6.0728 5.4708 5.4708 0 0 0-1.8604-4.4932c-1.6555-1.3989-4.073-1.7271-6.6782-0.96144l2.6992-19.726-1.9814-0.27148-3.1732 23.19 1.6547-0.75928c1.9183-0.87988 4.5516-1.3276 6.188 0.05518a3.5151 3.5151 0 0 1 1.1527 2.8955 6.1469 6.1469 0 0 1-2.3812 4.5278c-2.4667 1.8018-5.7462 2.0342-9.4658 2.1382z",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 166.55,
    y: 228.56,
    width: 10.772,
    height: 2,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132.55,
    y: 228.56,
    width: 10.772,
    height: 2,
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m428.36 628.12-18.356-134a6.0001 6.0001 0 0 0-5.9448-5.1857h-13.855a6.0247 6.0247 0 0 0 0.08985-1v-5a6.0002 6.0002 0 0 0-6-6h-12a6.0001 6.0001 0 0 0-6 6v5a6.0247 6.0247 0 0 0 0.08984 1h-13.855a6.0005 6.0005 0 0 0-5.9448 5.1857l-18.356 134a6 6 0 0 0 5.9443 6.8143h88.244a6 6 0 0 0 5.9444-6.8143z",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m399.8 560.56v-64.071l0.44482-0.04931a31.961 31.961 0 0 1 34.315 23.68l11.411 30.18z",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m375.26 463.88-35.275-13.692c-5.7683-2.2389-11.569-4.4097-17.307-6.7257a19.726 19.726 0 0 1-6.6615-3.9262 13.09 13.09 0 0 1-3.3211-6.427c-1.2235-5.1713-1.0023-10.825-0.915-16.102a122.7 122.7 0 0 1 1.4217-17.241 83.286 83.286 0 0 1 10.65-30.38c9.8927-16.232 26.937-28.444 46.543-27.469 9.0767 0.4512 18.206 3.7082 24.949 9.914a15.751 15.751 0 0 0 2.3551 2.2825 3.2678 3.2678 0 0 0 1.8757 0.12592q1.2344-0.07942 2.4709-0.12124a51.043 51.043 0 0 1 8.5655 0.35928 27.121 27.121 0 0 1 14.13 5.8674c3.3701 2.8991 6.1123 6.9917 6.3945 11.54a13.66 13.66 0 0 1-4.6143 11.151c-4.2085 3.5469-10.213 2.3002-15.261 2.0328l-27.864-1.4762c-1.9294-0.10222-1.9237 2.8981 0 3l24.905 1.3194c4.0022 0.212 8.127 0.73168 12.132 0.49169a13.574 13.574 0 0 0 8.3332-3.3524 16.628 16.628 0 0 0 5.0366-15.601c-1.284-6.1376-5.8518-11.215-11.207-14.235-7.2861-4.1098-15.988-4.5036-24.141-3.896l1.0607 0.43934c-9.2222-9.8982-23.349-14.077-36.61-12.615-14.002 1.5442-26.456 9.3558-35.404 20.038-9.9764 11.909-15.413 26.76-17.527 42.03a139.84 139.84 0 0 0-1.082 24.88 31.35 31.35 0 0 0 1.8523 10.751 15.39 15.39 0 0 0 7.2251 7.7461 103.4 103.4 0 0 0 11.468 4.7108l45.023 17.475c1.8009 0.699 2.581-2.2006 0.79752-2.8928z",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m319.8 361.93a15.5 15.5 0 1 1 15.5-15.5 15.517 15.517 0 0 1-15.5 15.5zm0-28a12.5 12.5 0 1 0 12.5 12.5 12.514 12.514 0 0 0-12.5-12.5z",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(147.61 -410.75) rotate(37.41)",
    x: 528.18,
    y: 440.82,
    width: 42.237,
    height: 42.237,
    fill: "#f0f0f0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m389.3 228.93a33.949 33.949 0 0 1 27.277 13.702l19.59-25.614-58.779-44.956-44.956 58.779 25.333 19.376a34.003 34.003 0 0 1 31.534-21.287z",
    fill: "#f0f0f0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m953 727.93h-706a1 1 0 0 1 0-2h706a1 1 0 0 1 0 2z",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m780.69 562h-71.862a10.011 10.011 0 0 1-10-10v-4.9775a10.011 10.011 0 0 1 10-10h71.862a10.011 10.011 0 0 1 10 10v4.9775a10.011 10.011 0 0 1-10 10z",
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-246 -172.07)",
    d: "m788.26 552.41h-71.862a10.512 10.512 0 0 1-10.5-10.5v-4.9775a10.512 10.512 0 0 1 10.5-10.5h71.862a10.512 10.512 0 0 1 10.5 10.5v4.9775a10.512 10.512 0 0 1-10.5 10.5zm-71.862-23.978a8.5095 8.5095 0 0 0-8.5 8.5v4.9775a8.5095 8.5095 0 0 0 8.5 8.5h71.862a8.5095 8.5095 0 0 0 8.5-8.5v-4.9775a8.5095 8.5095 0 0 0-8.5-8.5z",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.649a153962620bafaaaef234108dec71.svg";
export { ForwardRef as ReactComponent };